/* Rowing Precision — slide-out cart and search drawers.
   Ported from the concept's assets/cart.js + assets/search.js, but rewired to
   Shopify: the concept read a static RP_CATALOG and localStorage, this uses the
   real cart (/cart.js, /cart/change.js) and predictive search (/search/suggest.json).
   Styling is intentionally the concept's, so the panels look identical.
   Hooks: .cart and .hsearch in the header; [data-cart-count] for the badge. */
(function () {
  'use strict';

  /* ---------- shared styles ---------- */
  var css = [
    '.rpdrawer-ovl{position:fixed;inset:0;background:rgba(10,4,5,.5);z-index:98;opacity:0;',
    'pointer-events:none;transition:opacity .25s ease}',
    '.rpdrawer-ovl.open{opacity:1;pointer-events:auto}',
    '.rpdrawer{position:fixed;top:0;right:0;bottom:0;width:min(430px,100vw);background:#fff;z-index:99;',
    'transform:translateX(102%);transition:transform .3s cubic-bezier(.3,.8,.3,1);display:flex;',
    'flex-direction:column;box-shadow:-30px 0 80px -30px rgba(20,5,5,.5);color:#16090b}',
    '.rpdrawer.open{transform:none}',
    '.rpdrawer .hd{display:flex;align-items:center;justify-content:space-between;',
    'padding:18px 22px;border-bottom:1px solid #efe4e4}',
    '.rpdrawer .hd b{font-size:16px;font-weight:900;letter-spacing:-.01em}',
    '.rpdrawer .hd button{border:none;background:transparent;font-size:22px;cursor:pointer;color:#6e5a5c;line-height:1}',
    '.rpdrawer .items,.rpdrawer .res{flex:1;overflow-y:auto;padding:8px 22px}',
    '.rpdrawer .it{display:grid;grid-template-columns:64px 1fr auto;gap:14px;align-items:center;',
    'padding:14px 0;border-bottom:1px solid #f6ecec;text-decoration:none;color:inherit}',
    '.rpdrawer .it img{width:64px;height:56px;object-fit:cover;border-radius:10px;background:#f4eded}',
    '.rpdrawer .it .t{font-size:13px;font-weight:800;line-height:1.3;display:block}',
    '.rpdrawer .it .p{font-size:12.5px;color:#6e5a5c;font-weight:600;margin-top:2px;display:block}',
    '.rpdrawer .it .prop{font-size:11.5px;color:#6e5a5c;font-weight:600;margin-top:2px;display:block}',
    '.rpdrawer .it .prop b{color:#16090b;font-weight:800}',
    '.rpdrawer a.it:hover .t{color:#dc2626}',
    '.rpdrawer .qty{display:flex;align-items:center;gap:2px;border:1.5px solid #efe4e4;border-radius:999px;padding:2px}',
    '.rpdrawer .qty button{border:none;background:transparent;width:24px;height:24px;cursor:pointer;',
    'font-size:14px;font-weight:800;color:#6e5a5c;border-radius:50%}',
    '.rpdrawer .qty button:hover{background:#f4eded;color:#dc2626}',
    '.rpdrawer .qty span{min-width:20px;text-align:center;font-size:13px;font-weight:800}',
    '.rpdrawer .rm{border:none;background:none;color:#b9a2a4;font-size:11px;cursor:pointer;',
    'text-decoration:underline;margin-top:4px;padding:0}',
    '.rpdrawer .empty,.rpdrawer .none{text-align:center;color:#6e5a5c;padding:56px 20px;font-size:14px}',
    '.rpdrawer .empty b,.rpdrawer .none b{display:block;font-size:17px;color:#16090b;margin-bottom:6px}',
    '.rpdrawer .ft{border-top:1px solid #efe4e4;padding:18px 22px 22px}',
    '.rpdrawer .sub{display:flex;justify-content:space-between;font-size:15px;font-weight:900;margin-bottom:4px}',
    '.rpdrawer .note{font-size:11.5px;color:#6e5a5c;margin-bottom:14px}',
    '.rpdrawer .co,.rpdrawer .all{display:block;width:100%;text-align:center;background:#dc2626;color:#fff;border:none;',
    'border-radius:999px;padding:15px;font:inherit;font-size:15px;font-weight:800;cursor:pointer;text-decoration:none}',
    '.rpdrawer .co:hover,.rpdrawer .all:hover{background:#c81e1e}',
    '.rpdrawer .vc{display:block;text-align:center;margin-top:11px;font-size:12.5px;color:#6e5a5c;',
    'font-weight:700;text-decoration:underline}',
    '.rpdrawer .vc:hover{color:#dc2626}',
    '.rpdrawer .box{display:flex;align-items:center;gap:10px;margin:16px 22px 4px;border:1.5px solid #efe4e4;',
    'border-radius:999px;padding:11px 18px}',
    '.rpdrawer .box:focus-within{border-color:#dc2626}',
    '.rpdrawer .box svg{flex-shrink:0;color:#6e5a5c}',
    '.rpdrawer .box input{border:none;outline:none;font:inherit;font-size:14.5px;font-weight:600;width:100%;',
    'background:transparent;color:#16090b}',
    '.rpdrawer .sr{display:grid;grid-template-columns:64px 1fr;gap:14px}',
    '.cartn.bump{animation:rpbump .3s ease}',
    '@keyframes rpbump{50%{transform:scale(1.5)}}'
  ].join('');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var ovl = document.createElement('div'); ovl.className = 'rpdrawer-ovl';
  document.body.appendChild(ovl);

  function mk(html) {
    var el = document.createElement('aside');
    el.className = 'rpdrawer';
    el.innerHTML = html;
    document.body.appendChild(el);
    el.querySelector('.hd button').addEventListener('click', closeAll);
    return el;
  }
  function closeAll() {
    ovl.classList.remove('open');
    cartDr.classList.remove('open');
    searchDr.classList.remove('open');
    document.documentElement.style.overflow = '';
  }
  function show(dr) {
    cartDr.classList.remove('open'); searchDr.classList.remove('open');
    ovl.classList.add('open'); dr.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }
  ovl.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- money ---------- */
  // Shopify gives cents; the theme shows whole-dollar prices, so match that and
  // only show cents when they are non-zero.
  function money(cents) {
    var n = (cents || 0) / 100;
    var s = n % 1 === 0 ? n.toLocaleString('en-CA') : n.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + s;
  }

  /* ---------- cart drawer ---------- */
  var cartDr = mk(
    '<div class="hd"><b>Your cart</b><button aria-label="Close">&times;</button></div>' +
    '<div class="items"></div>' +
    '<div class="ft">' +
    '<div class="sub"><span>Subtotal</span><span class="subv">$0</span></div>' +
    '<div class="note">Shipping &amp; taxes calculated at checkout.</div>' +
    '<a class="co" href="/checkout">Checkout</a>' +
    '<a class="vc" href="/cart">View full cart</a>' +
    '</div>');

  var itemsEl = cartDr.querySelector('.items');
  var subEl = cartDr.querySelector('.subv');
  var ftEl = cartDr.querySelector('.ft');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var lastCart = null;
  function isFee(it) { return it.handle === 'custom-colour'; }
  function ccOf(it) { return it.properties && it.properties._cc ? String(it.properties._cc) : ''; }
  function renderCart(cart) {
    lastCart = cart;
    setBadge(cart.item_count);
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="empty"><b>Your cart is empty</b>Add something and it will show up here.</div>';
      ftEl.style.display = 'none';
      return;
    }
    ftEl.style.display = '';
    subEl.textContent = money(cart.total_price);
    itemsEl.innerHTML = cart.items.map(function (it, i) {
      // Line item properties are what make a custom seat pad distinguishable
      // from a stock one. "_" keys are Shopify's hidden-metadata convention.
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          var v = it.properties[k];
          if (!k || k.charAt(0) === '_' || !v) return;
          props += /:\/\//.test(v)
            ? '<span class="prop"><b>' + esc(k) + ':</b> <a href="' + esc(v) + '" target="_blank" rel="noopener">View / edit</a></span>'
            : '<span class="prop"><b>' + esc(k) + ':</b> ' + esc(v) + '</span>';
        });
      }
      var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '">' : '<img alt="">';
      // A Custom Colour line tied to a device (_cc) has no controls of its own: it is removed
      // with its device and its quantity follows the device's. Untied ones (older carts) behave as before.
      var locked = isFee(it) && ccOf(it);
      return '<div class="it">' + img +
        '<span><a class="t" href="' + esc(it.url) + '" style="text-decoration:none;color:inherit">' + esc(it.product_title) + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="p">' + esc(it.variant_title) + '</span>' : '') +
        props +
        '<span class="p">' + money(it.final_line_price) + '</span>' +
        (locked ? '<span class="p" style="font-size:11.5px">Removed with the item above</span>' : '<button class="rm" data-line="' + (i + 1) + '">Remove</button>') + '</span>' +
        (locked ? '<span class="qty"><span>' + it.quantity + '</span></span>' :
        '<span class="qty"><button data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '">+</button></span>') +
        '</div>';
    }).join('');
    upsell(cart);
  }

  /* ---------- CrewLogger plan offer (Adam 2026-10-27) ----------
     One quiet line under the items, offered once the buyer has decided, never in the
     way of Add to cart (a pop-up for this was mocked and rejected as too much friction).
     Devices and the BladeWork / CoxPro bundles offer Athlete Pro; the Coach Launch System
     and the Long Range Repeater (bought by coaches, Adam 2026-10-28) offer Coach Pro. Hidden once any plan is in the cart. The plan is a normal store
     product: the orders/paid webhook on crewlogger.com emails the activation key.
     Mirrored server-side on the cart page (templates/cart.liquid). */
  var PLAN_HANDLES = ['athlete-pro', 'coach-pro', 'team-ultimate'];
  var ATHLETE_FOR = ['rpx-440', 'rpx-270', 'oar-dynamics-sensor', 'coxpro-audio', 'bladework-bundle', 'coxpro-complete-kit'];
  var PLAN_COPY = {
    'athlete-pro': 'Speed curves, live streaming and GoPro video synced to every stroke.',
    'coach-pro': 'Film from the launch with the app, synced to every stroke. Unlimited athletes.'
  };
  var planCache = {};
  function wantedPlan(cart) {
    var want = '';
    for (var i = 0; i < cart.items.length; i++) {
      var h = cart.items[i].handle;
      if (PLAN_HANDLES.indexOf(h) >= 0) return '';
      if (h === 'coach-launch-system' || h === 'repeater') want = 'coach-pro';
      else if (!want && ATHLETE_FOR.indexOf(h) >= 0) want = 'athlete-pro';
    }
    return want;
  }
  function loadPlan(h) {
    if (!planCache[h]) {
      planCache[h] = fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.variants || !p.variants.length) return null;
          var v = p.variants.filter(function (x) { return x.available; })[0];
          return v ? { id: v.id, price: v.price, title: p.title, img: p.featured_image } : null;
        })
        .catch(function () { return null; });
    }
    return planCache[h];
  }
  function upsell(cart) {
    var h = wantedPlan(cart);
    if (!h) return;
    loadPlan(h).then(function (p) {
      if (!p || lastCart !== cart) return;
      var row = document.createElement('div');
      row.className = 'it';
      row.style.cssText = 'background:#faf7f7;border-radius:12px;padding:12px;margin:12px 0 4px;border:none';
      row.innerHTML = (p.img ? '<img src="' + esc(p.img) + '" alt="">' : '<img alt="">') +
        '<span><span class="t">Add CrewLogger ' + esc(p.title) + '</span>' +
        '<span class="prop">' + esc(PLAN_COPY[h]) + '</span>' +
        '<span class="p">' + money(p.price) + ' / year</span></span>' +
        '<button type="button" style="border:2px solid #16090b;background:#fff;color:#16090b;border-radius:999px;' +
        'padding:7px 16px;font:inherit;font-size:12.5px;font-weight:800;cursor:pointer">Add</button>';
      var btn = row.querySelector('button');
      btn.addEventListener('click', function () {
        btn.disabled = true; btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: p.id, quantity: 1 }] })
        }).then(function () { return fetchCart(); }).then(renderCart)
          .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
      });
      itemsEl.appendChild(row);
    });
  }

  function setBadge(n) {
    document.querySelectorAll('[data-cart-count], .cartn').forEach(function (el) {
      el.textContent = n;
      el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 320);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function changeKey(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  // Change a line and carry its tied Custom Colour lines along: gone when the device goes,
  // quantity scaled when the device quantity changes (fee qty / device qty stays constant).
  function changeLine(line, qty) {
    var it = lastCart && lastCart.items ? lastCart.items[line - 1] : null;
    var cc = it ? ccOf(it) : '';
    var fees = (cc && !isFee(it) && lastCart) ? lastCart.items.filter(function (x) { return isFee(x) && ccOf(x) === cc; }) : [];
    var chain = Promise.resolve();
    fees.forEach(function (f) {
      var fq = qty === 0 ? 0 : Math.max(1, Math.round(f.quantity * qty / Math.max(1, it.quantity)));
      chain = chain.then(function () { return changeKey(f.key, fq); });
    });
    return chain.then(function () { return it ? changeKey(it.key, qty) : fetchCart(); }).then(renderCart);
  }

  itemsEl.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var line = parseInt(b.getAttribute('data-line'), 10);
    if (!line) return;
    e.preventDefault();
    if (b.classList.contains('rm')) { changeLine(line, 0); return; }
    var q = parseInt(b.getAttribute('data-q'), 10);
    changeLine(line, Math.max(0, q));
  });

  document.querySelectorAll('.cart').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      show(cartDr);
      itemsEl.innerHTML = '<div class="empty">Loading&hellip;</div>';
      fetchCart().then(renderCart);
    });
  });

  /* ---------- search drawer ---------- */
  var searchDr = mk(
    '<div class="hd"><b>Search</b><button aria-label="Close">&times;</button></div>' +
    '<div class="box">' +
    '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
    '<input type="search" placeholder="Search products&hellip;" aria-label="Search products">' +
    '</div>' +
    '<div class="res"></div>' +
    '<div class="ft"><a class="all" href="/search">Browse all products</a></div>');

  var sInput = searchDr.querySelector('input');
  var sRes = searchDr.querySelector('.res');
  var sAll = searchDr.querySelector('.all');
  var sTimer = null;

  function searchUrl(q) { return '/search?q=' + encodeURIComponent(q); }

  function renderSearch() {
    var q = sInput.value.trim();
    sAll.href = q ? searchUrl(q) : '/collections/all-products';
    sAll.textContent = q ? 'See all results for “' + q + '”' : 'Browse all products';
    if (!q) {
      sRes.innerHTML = '<div class="none">Type to search — try “RPX”, “CoxPro”, or “mount”.</div>';
      return;
    }
    // Shopify predictive search — replaces the concept's static catalogue match.
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); }).then(function (d) {
      var hits = (d.resources && d.resources.results && d.resources.results.products) || [];
      if (!hits.length) {
        sRes.innerHTML = '<div class="none"><b>No matches for “' + esc(q) + '”</b>Try a product name like RPX, CoxPro, BladeWork, or mount.</div>';
        return;
      }
      sRes.innerHTML = hits.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + esc(p.featured_image.url) + '" alt="' + esc(p.title) + '">'
          : '<img alt="">';
        // NOTE predictive search returns price as a DOLLAR STRING ("679.00"),
        // unlike /cart.js which returns cents. Do not run it through money().
        var price = p.available === false ? 'Sold out' : (p.price ? '$' + String(p.price).replace(/\.00$/, '') : '');
        return '<a class="it sr" href="' + esc(p.url) + '">' + img +
          '<span><span class="t">' + esc(p.title) + '</span>' +
          '<span class="p">' + price + '</span></span></a>';
      }).join('');
    }).catch(function () {
      sRes.innerHTML = '<div class="none">Search is unavailable right now.</div>';
    });
  }

  document.querySelectorAll('.hsearch').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      show(searchDr);
      renderSearch();
      setTimeout(function () { sInput.focus(); }, 120);
    });
  });
  sInput.addEventListener('input', function () {
    clearTimeout(sTimer);
    sTimer = setTimeout(renderSearch, 180);
  });
  sInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = sInput.value.trim();
      if (q) location.href = searchUrl(q);
    }
  });

  // Keep the badge honest if something else on the page adds to cart.
  document.addEventListener('rp:cart-updated', function () { fetchCart().then(renderCart); });
})();
